import 'reflect-metadata';
import { jsonObject, jsonMember, toJson } from 'typedjson';

@jsonObject
@toJson
export class SolarLevel {
  @jsonMember voltageMv!: number; // tension panneau en mV
  @jsonMember currentMa!: number; // courant en mA
  @jsonMember powerMw!: number; // puissance en mW

  @jsonMember charging!: boolean; // true/false (si tu renvoies 0/1 côté API, dis-moi et on adapte)
  @jsonMember valid!: boolean;

  @jsonMember date!: Date; // idem BatteryLevel
}
